import React from 'react';

const steps = [
  {
    number: '1',
    title: 'Upload Your Video',
    description: 'Select your video file and upload it directly to our secure cloud storage. Supports MP4, AVI, MOV, MKV, and WebM formats.',
    icon: '📤'
  },
  {
    number: '2',
    title: 'Automatic Processing',
    description: 'Our system automatically processes your video.',
    icon: '⚙️'
  },
  {
    number: '3',
    title: 'Download Results',
    description: 'Get your processed video or scene archive instantly. Files are automatically deleted 24 hours after upload for your privacy.',
    icon: '⬇️'
  }
];

const HowItWorks = () => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Three simple steps to process your videos:
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection line (hidden on mobile) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-gradient-to-r from-blue-500 to-transparent" />
              )}
              
              <div className="relative z-10 text-center">
                {/* Step number badge */}
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-500 text-white text-2xl font-bold mb-4 shadow-lg">
                  {step.number}
                </div>
                
                {/* Icon */}
                <div className="text-5xl mb-4">{step.icon}</div>
                
                {/* Title */}
                <h3 className="text-xl font-semibold text-white mb-3">
                  {step.title}
                </h3>
                
                {/* Description */}
                <p className="text-gray-300 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
